import { useEffect } from 'react';
import { useToast } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';
import { subscribeToReleaseNotice } from '@/lib/release-notice';

/**
 * Turns a release drift into a persistent, dismissible offer to reload. The
 * reload is never automatic: it would destroy whatever the user was typing.
 */
export function ReleaseNoticeBridge() {
  const toast = useToast();
  const t = useTranslations('common.release-notice');

  useEffect(() => {
    return subscribeToReleaseNotice(() => {
      toast.info(t('title'), {
        description: t('description'),
        action: { label: t('action'), onClick: () => window.location.reload() },
        duration: null,
      });
    });
  }, [toast, t]);

  return null;
}
